import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { StepNavigatorWrapper } from 'Components/ComponentLibrary/Molecules/StepNavigator/StepNavigatorWrapper';
import { FDBackButton, FDPrimaryActionButton } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import useMobileLayout from 'Hooks/useMobileLayout';

const useStyles = buildUseStyles('StepNavigationFooter', (theme) => ({
  root: {
    position: 'fixed',
    zIndex: 1,
    bottom: 0,
    left: 0,
    width: '100%',
  },
  aboveMobileNav: {
    bottom: theme.heights.mobileBottomNavigationHeight,
  },
}));

const StepNavigationFooter = ({
  onNext,
  onPrevious,
  isLoading,
  label,
  disabled,
  paperColor,
  isMobileNavShown = false,
}) => {
  const isMobile = useMobileLayout();
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, (isMobile && isMobileNavShown) && classes.aboveMobileNav)}>
      <StepNavigatorWrapper paperColor={paperColor}>
        {onPrevious ? <FDBackButton disabled={disabled} onClick={onPrevious} loading={isLoading} {...dataAttrs('back-btn')} /> : null}
        {onNext ? <FDPrimaryActionButton disabled={disabled} onClick={onNext} size="lg" label={label} loading={isLoading} isFullWidth {...dataAttrs('continue-btn')} /> : null}
      </StepNavigatorWrapper>
    </div>
  );
};

StepNavigationFooter.defaultProps = {
  onNext: null,
  onPrevious: null,
  label: 'Continue',
  isLoading: false,
  disabled: false,
  paperColor: undefined,
};

StepNavigationFooter.propTypes = {
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  isLoading: PropTypes.bool,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  paperColor: PropTypes.string,
};

export default StepNavigationFooter;
